import CatalogSource from "@/api/CatalogSource.js";

export const productDetailModule = {
    state: () => ({
        isLoading: true,
        product: null,
    }),

    actions: {
        async load({state}, id) {
            state.isLoading = true;
            try {
                await this.$API.manager.getSource(CatalogSource).getProductById(id).then((response) => {
                    state.product = response;
                });
            } finally {
                state.isLoading = false;
            }
        },
        async loadBySlug({state, rootState}, slug) {
            console.log(slug);
            state.isLoading = true;
            try {
                await this.$API.manager.getSource(CatalogSource).getProductBySlug(slug).then((response) => {
                    state.product = response;

                    rootState.lastModified = response?.date_modified ?? null;
                    return true;
                });
            } finally {
                state.isLoading = false;
            }
        },
    },
    namespaced: true
}
